import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { JSend } from '../../models/jsend.model';
import { TorresCredentials } from '../models/torres-credentials.model';

@Injectable({
  providedIn: 'root'
})
export class TorresService {

  private baseUrl = '/:apiBase/companies/:companyId/torres/credentials';

  constructor(
    private http: HttpClient
  ) { }

  public get(companyId: number): Observable<TorresCredentials> {
    const url = this.baseUrl.replace(':companyId', companyId.toString());

    return this.http.get<JSend<{ credentials: TorresCredentials }>>(url)
      .pipe(map(response => this.toModel(response.data.credentials)));
  }

  public save(companyId: number, credentials: TorresCredentials): Observable<TorresCredentials> {
    const url = this.baseUrl.replace(':companyId', companyId.toString());

    return this.http.put<JSend<{ credentials: TorresCredentials }>>(url, { apiKey: credentials.apiKey })
      .pipe(map(response => this.toModel(response.data.credentials)));
  }

  /**
   * El interviniente (Cereales Javier SA) lo resuelve el backend por CUIT; el
   * front solo maneja la API Key.
   */
  private toModel(data: TorresCredentials): TorresCredentials {
    return plainToInstance(TorresCredentials, {
      apiKey: data?.apiKey
    });
  }
}
